<survey-component
  accesstoken="{{ accessToken() }}"
  userid="{{ userId() }}"
  userlanguage="{{ userLanguage() }}"
  usercountry="{{ userCountry() }}"
  embeddedanchorpointid="{{ embeddedAnchorPointId }}"
  iconanchorpointid="{{ iconAnchorPointId }}"
  basepath="{{ basePath }}"
  hash="{{ hash() }}">
</survey-component>
